// extracted by mini-css-extract-plugin
export var bodyRow = "_ep-d";
export var cardColumns = "_ep-e";
export var ellipsesOverflow = "_ep-2";
export var flatBottomCorners = "_ep-3";
export var flatTopCorners = "_ep-4";
export var headerActionsDropdown = "_ep-f";
export var headerBottomRow = "_ep-c";
export var headerTopRow = "_ep-b";
export var orderDetailsWrapper = "_ep-0";
export var orderInfoContainer = "_ep-1";
export var productDetails = "_ep-9";
export var productImage = "_ep-5";
export var responsiveTable = "_ep-8";
export var shipmentContainer = "_ep-a";
export var tableBottomLeft = "_ep-6";
export var tableBottomRight = "_ep-7";
export var trackingLink = "_ep-g";